import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/Service/auth.service';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    CommunicationHandler: any; // Replace SomeType with the actual type of CommunicationHandler
  }
}
@Component({
    selector: 'app-pcisbuscription',
    templateUrl: './pcisbuscription.component.html',
    standalone: false
})
export class PcisbuscriptionComponent {
  constructor( private auth:AuthService){}
  subscriptions: Subscription = new Subscription();
  authorizePaymentGateWay() {
    const amount = 400;
   this.subscriptions.add(
      this.auth
        .GetPciSubscriptionToken({ amount: amount })
        .subscribe((res: any) => {
          if (res) {
            const tokenInput = document.getElementById(
              'token'
            ) as HTMLInputElement;
            const addPciPayment = document.getElementById(
              'add_pci_payment'
            ) as HTMLIFrameElement;
            tokenInput.value = res.data;
            addPciPayment.style.display = 'block';
            const sendPciTokenForm = document.getElementById(
              'send_pci_token'
            ) as HTMLFormElement;
            sendPciTokenForm.action = environment.authorizeIFrameUrl;
            sendPciTokenForm.target = 'add_pci_payment';
            sendPciTokenForm.submit();
            window.scrollTo(0, addPciPayment.offsetTop - 50);
          } else {
            // Handle the case where response is empty.
          }
        })
    );
  }
  ngOnInit(){
    window.CommunicationHandler = {};
    window.CommunicationHandler.onReceiveCommunication = function (
      argument: any
    ) {
      const params = parseQueryString(argument.qstr);

      switch (params['action']) {
        case 'resizeWindow':
          break;
        case 'successfulSave':
          break;
        case 'cancel':
          break;
        case 'transactResponse':
          const ifrm = document.getElementById(
            'add_pci_payment'
          ) as HTMLIFrameElement | null;

          if (ifrm) {
            ifrm.style.display = 'none';     
          }

          break;
      }
    };
  }

}
function parseQueryString(str: string): { [key: string]: string } {
  const vars: { [key: string]: string } = {};
  const arr: string[] = str.split('&');
  let pair: string[];

  for (let i = 0; i < arr.length; i++) {
    pair = arr[i].split('=');
    vars[pair[0]] = decodeURIComponent(pair[1]);
  }

  return vars;
}